module.exports = __webpack_public_path__ + "img/ic_star_border_24px_yellow.5611db16.svg";